import { useGetProjectByIdQuery } from 'app/services/projects';
import {
  questionnairesApi,
  useGetQuestionnaireByIdQuery,
} from 'app/services/questionnaires';
import Spinner from 'Components/Spinner';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import EditQuestionnaireRoutes from '../edit/routes';
import { selectPreviewQuestionnaire } from '../edit/TaxQuestionnaire/togglePreviewSlice';
import PreviewQuestionnaire from './PreviewQuestionnaire';

export interface IShowQuestionnaireProps {
  preview?: boolean;
}

export default function ShowQuestionnaire({
  preview,
}: IShowQuestionnaireProps) {
  const { questionnaireId } = useParams();
  const dispatch = useDispatch();
  const { isPreview } = useSelector(selectPreviewQuestionnaire);

  const { isClient, isAccountant, isAdmin } = useAuth();

  const {
    data: quesitonnaireData,
    isLoading: questionnaireIsLoading,
    isError: quesitonnaireIsError,
  } = useGetQuestionnaireByIdQuery(questionnaireId!, {
    skip: !questionnaireId,
  });

  const { data: projectData, isLoading: projectIsLoading } =
    useGetProjectByIdQuery(questionnaireId!, {
      skip: !questionnaireId,
    });

  const showPreviewQuestionnaire = isAccountant || isAdmin;

  useEffect(() => {
    return () => {
      dispatch(questionnairesApi.util.resetApiState());
    };
  }, []);

  return (
    <>
      {!questionnaireIsLoading && (
        <>
          {!isPreview && isClient && !preview && <EditQuestionnaireRoutes />}
          {(isPreview || showPreviewQuestionnaire || preview) && (
            <PreviewQuestionnaire
              taxReturn={projectData?.project}
              clients={projectData?.project.clients}
              preview={preview}
              showCloseBtn={isClient && !showPreviewQuestionnaire && !preview}
              isEdited={
                quesitonnaireData &&
                projectData?.project?.tax_return_status !== 'draft'
                  ? quesitonnaireData?.questionnaire?.editted
                  : false
              }
            />
          )}
        </>
      )}
      {quesitonnaireIsError && <p>Not Found</p>}
      {questionnaireIsLoading && (
        <div className="pt-16">
          <Spinner />
        </div>
      )}
    </>
  );
}
